export * from "./types";
export { default as WLTabs } from "./Tabs.vue";
